module.exports = __webpack_public_path__ + "img/schleswig-holstein.66235a6.webp";